import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { label: "Privacy Policy", href: "/privacy", isRoute: true },
  { label: "Terms of Service", href: "/terms", isRoute: true },
  { label: "Partner With Us", href: "/partners", isRoute: true },
  { label: "Resources", href: "/resources", isRoute: true },
  { label: "Blog", href: "/blog", isRoute: true },
  { label: "Videos", href: "/videos", isRoute: true },
  { label: "Podcast", href: "/podcast", isRoute: true },
  { label: "FAQ", href: "/faq", isRoute: true },
  { label: "Accessibility Statement", href: "/#accessibility", isRoute: false },
  { label: "About NeuroNest", href: "/#about", isRoute: false },
  {
    label: "Contact / Support",
    href: "mailto:hello@neuronest.global",
    isRoute: false,
  },
];

const HASHTAGS = [
  "#NeuroNest",
  "#SensorySafe",
  "#NeurodivergentTools",
  "#ActuallyAutistic",
  "#ADHDTools",
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#2F3A56] text-white py-16 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <img
                src={`${process.env.PUBLIC_URL}/logo.webp`}
                alt=""
                className="w-8 h-8 rounded-lg"
                loading="lazy"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <h3 className="font-heading text-xl font-bold text-brand-teal">
                NeuroNest
              </h3>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              Your sensory-support and predictability companion. Tools designed
              with your nervous system in mind.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-widest text-white/40 mb-4">
              Links
            </h4>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((link) => (
                <li key={link.label}>
                  {link.isRoute ? (
                    <Link
                      to={link.href}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-white/60 hover:text-brand-teal transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-white/60 hover:text-brand-teal transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-widest text-white/40 mb-4">
              Community
            </h4>
            <div className="flex flex-wrap gap-2">
              {HASHTAGS.map((tag) => (
                <span
                  key={tag}
                  className="text-xs bg-white/10 text-white/50 px-3 py-1.5 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} NeuroNest. Built with care.
            Designed with empathy. Shipped with intention.
          </p>
          <p className="text-xs text-white/40 italic">
            "Your data, like your experience, is yours."
          </p>
        </div>
      </div>
    </footer>
  );
}
